import React, { useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import KBTile from './KBTile'
import { fetchAllKB, showKbSettingsModal, setActiveKb } from 'Actions/kb'
import { getAllKB, getModalState, getKB } from 'Selectors/kb'
import SettingsModal from './SettingsModal'

const KnowledgeBaseList = () => {
  const navigate = useNavigate()
  const showModal = useSelector(getModalState)
  const activeKB = useSelector(getKB)
  const dispatch = useDispatch()
  const kbList = useSelector(getAllKB)

  useEffect(() => {
    dispatch(fetchAllKB({}))
  }, [dispatch, showModal])

  const onAddClick = () => {
    navigate('/knowledge-base-import', { state: { showCloseButton: true } })
  }

  const onShowModal = useCallback(
    (kb) => {
      dispatch(setActiveKb({ kb }))
      dispatch(showKbSettingsModal({ showModal: true }))
    },
    [dispatch]
  )

  const onHideModal = useCallback(() => {
    dispatch(showKbSettingsModal({ showModal: false }))
  }, [dispatch])

  return (
    <div className='kb-container'>
      <div className='page-top-bar'>
        <div className='title'>Knowledge Base</div>
        <div className='right'>
          <button onClick={onAddClick} className='button-primary'>
            Add a Knowledge Base
          </button>
        </div>
      </div>

      <div className='list-container d-flex flex-wrap'>
        {!kbList.length && <KBTile status='loading' />}
        {kbList.map((kb) => {
          return (
            <KBTile
              key={kb.id}
              id={kb.id}
              name={kb.name}
              source={kb.settings.account_url}
              noOfarticles={kb.articles_count}
              noOfignoredSections={kb.ignored_sections.length}
              type={kb.source_type}
              syncStatus={kb.sync_status}
              lastSyncAt={kb.last_sync_at}
              showModal={() => onShowModal(kb)}
            />
          )
        })}
      </div>

      {showModal && <SettingsModal kb={activeKB} hide={onHideModal} open={showModal} />}
    </div>
  )
}

export default KnowledgeBaseList
